module.exports = __webpack_public_path__ + "static/benefits-img7-3594ff7303379a4b73bc77d2b294bc46.png";